import Cookies from 'js-cookie'
import Router from '../router/modules'

const menus = () => {
  const JSONData = Cookies.get('accessIds')
  const accessIds = [100000, 100100, 100200, 110000, 110100, 110200, 110201, 110202]
  const filterRouters = filterRoutes(Router, accessIds)

  function filterRoutes(routes, accessIds) {
    return routes.filter(route => {
      const { meta = {} } = route
      const { hidden } = meta

      if (!hidden) {
        if (route.children) {
          route.children = filterRoutes(route.children, accessIds)
        }

        return true
      } else {
        return false
      }
    })
  }

  return filterRouters
}

export default menus
